import { IEntity } from "../interfaces/ientity";
import { IDisable } from "../interfaces/idisable";

export enum LatestUpdateType {
    CategoryDetailLatestUpdate,
    CountryDashboardDescriptionLatestUpdate,
    EventLatestUpdate,
    GenericLatestUpdate
}

export abstract class LatestUpdate implements IEntity, IDisable  {
    constructor(countryId: number,
        businessFunctionId: number,
        description: string,
        url: string,
        latestUpdateType: LatestUpdateType,
        sendEmail: boolean) {
        this.countryId = countryId;
        this.businessFunctionId = businessFunctionId;
        this.description = description;
        this.url = url;
        this.latestUpdateType = latestUpdateType;
        this.sendEmail = sendEmail;
    }
    id: number;
    countryId: number;
    countryName: string;
    businessFunctionId: number;
    description:string;
    url: string;
    disabled: boolean;
    createdDate:string;
    latestUpdateType: LatestUpdateType;
    sendEmail: boolean;
}

export class CategoryDetailLatestUpdate extends LatestUpdate {
    constructor(countryId: number,
        businessFunctionId: number,
        description: string,
        countryCode: string,
        categoryId: number,
        defaultRoute: string,
        sendEmail: boolean) {
        let url: string = `${defaultRoute}/countryinformation/${countryCode}/${categoryId}`;
        super(countryId, businessFunctionId, description, url, LatestUpdateType.CategoryDetailLatestUpdate, sendEmail);
    }
}

export class CountryDashboardDescriptionLatestUpdate extends LatestUpdate {
    constructor(countryId: number,
        businessFunctionId: number,
        description: string,
        countryCode: string,
        defaultRoute: string,
        sendEmail: boolean) {
        let url: string = `${defaultRoute}/countryinformation/${countryCode}`;
        super(countryId, businessFunctionId, description, url, LatestUpdateType.CountryDashboardDescriptionLatestUpdate, sendEmail);
    }
}

export class EventLatestUpdate extends LatestUpdate {
    constructor(countryId: number,
        businessFunctionId: number,
        description: string,
        countryCode: string,
        url: string,
        defaultRoute: string,
        sendEmail: boolean) {
        if (url == null || url.length <= 0) {
            url = `${defaultRoute}/countryinformation/${countryCode}`;
        }
        super(countryId, businessFunctionId, description, url, LatestUpdateType.EventLatestUpdate, sendEmail);
    }
}